import { render, staticRenderFns } from "./ManualListAccess.vue?vue&type=template&id=18b3bc18&scoped=true&"
import script from "./ManualListAccess.vue?vue&type=script&lang=js&"
export * from "./ManualListAccess.vue?vue&type=script&lang=js&"
import style0 from "./ManualListAccess.vue?vue&type=style&index=0&id=18b3bc18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b3bc18",
  null
  
)

export default component.exports